// extracted by mini-css-extract-plugin
module.exports = {"curved-text_text":"CurvedText_curved-text_text__MKWpP","curved-text_root":"CurvedText_curved-text_root__Z5xS1","curved-text_non-root":"CurvedText_curved-text_non-root__2aRc1"};